<form [formGroup]="filterForm" (submit)="filterProperties()">

  <div class="filter">
    <div class="item">
      <ion-select interface="popover"
                  formControlName="city"
                  [placeholder]="'Preferred neighbourhood'">
        @for (city of propertyService.subCities; track city) {
          <ion-select-option [value]="city">{{ city}}</ion-select-option>
        }
      </ion-select>
    </div>
    <div class="item">

      <ion-select interface="popover"
                  formControlName="sub"
                  [placeholder]="'Unit Type'">
        @for (sub of propertyService.subCategories(); track sub._id) {
          <ion-select-option [value]="sub._id">{{languageService.lang() === 'en' ? sub.nameEn : sub.nameAr}}</ion-select-option>
        }
      </ion-select>
    </div>
    <div class="item no-border">

      <ion-select interface="popover"
                  [multiple]="true"
                  [placeholder]="'Furnished, Unfurnished'">

        @for (f of content?.furnishingType; track f.id) {
          <ion-select-option [value]="f.value">{{ f.label }}</ion-select-option>
        }
      </ion-select>
    </div>
    <span><ion-button type="submit"><ion-icon name="search"></ion-icon></ion-button></span>
  </div>

</form>
